import handlebars from 'handlebars';
const eq = (a: any, b: any) => a === b;

// Register the 'eq' helper with Handlebars
handlebars.registerHelper('eq', eq)
const summaryTemplate = `
<!DOCTYPE html>
<html>
  <head>      
  </head>
  <body>
    <div class="row summary-info-table">
      <h2 class="pdf-table-heading">Investment Summary</h2>
      <!-- left table -->
      <div class="column">
        
        <table id= "leasing-table">
          {{#if summaryData.investmentId}}
          <tr>
            <td>ID:</td>
            <td>{{summaryData.investmentId}}</td>
          </tr>
          {{/if}}
          {{#if summaryData.fundName}}
          <tr>
            <td>Fund Name:</td>
            <td>{{summaryData.fundName}}</td>
          </tr>
          {{/if}}
          {{#if summaryData.city}}
          <tr>
            <td>City / State:</td>
            <td>{{summaryData.city}}</td>
          </tr>
          {{/if}}
          {{#if formattedData.yearBuilt}}
          <tr>
            <td>Year Built:</td>
            <td>{{formattedData.yearBuilt}}</td>
          </tr>
          {{/if}}
          {{#if formattedData.dateAcquired}}
          <tr>
            <td>Date Acquired:</td>
            <td>{{formattedData.dateAcquired}}</td>
          </tr>
          {{/if}}
          {{#if formattedData.purchasedPrice}}
          <tr>
            <td>Purchase Price:</td>
            <td>{{formattedData.purchasedPrice}}</td>
          </tr>
          {{/if}}
          {{#if formattedData.appraisedValue}}
          <tr>
            <td>Appraised Value:</td>
            <td>{{formattedData.appraisedValue}}</td>
          </tr>
          {{/if}}
          {{#if formattedData.totalCapEx}}
          <tr>
            <td>Capitalised expenses post acquisition:</td>
            <td>{{formattedData.totalCapEx}}</td>
          </tr>
          {{/if}}
          {{#if formattedData.bookCostField}}
          <tr>
            <td>Book Cost:</td>
            <td>{{formattedData.bookCostField}}</td>
          </tr>
          <tr>
            <td>Book Cost (Last Closing Period):</td>
            <td>{{formattedData.lastClosedPeriod}}</td>
          </tr>
          {{/if}}
          {{#if summaryData.assetManager.firstName}}
          <tr>
            <td>Asset Manager:</td>
            <td>{{summaryData.assetManager.lastName}}, {{summaryData.assetManager.firstName}}</td>
          </tr>
          {{/if}}
          {{#if summaryData.portfolioManager.firstName}}
          <tr>
            <td nowrap>Portfolio Manager:</td>
            <td>{{summaryData.portfolioManager.lastName}}, {{summaryData.portfolioManager.firstName}}</td>
          </tr>
          {{/if}}
        </table>
      </div>
      <!-- right table -->
      <div class="column">
       
        <table id= "leasing-table">

		    {{#if (eq summaryData.propertyType 'Residential')}}
			{{#if formattedData.units}}
			<tr>
        <td>Units:</td>
        <td>{{formattedData.units}}</td>
		</tr>
		{{/if}}
  {{else if (eq summaryData.propertyType 'Commertial')}}
  {{#if formattedData.rentableArea}}
  <tr>
        <td>Rentable Area (sqft):</td>
        <td>{{formattedData.rentableArea}}</td>
		</tr>
	{{/if}}
  {{else if (eq summaryData.propertyType 'Mixed')}}
{{#if formattedData.units}}
<tr>
        <td>Units:</td>
        <td>{{formattedData.units}}</td>
      </tr>
{{/if}}
{{#if formattedData.rentableArea}}
      <tr>
        <td>Rentable Area (sqft):</td>
        <td>{{formattedData.rentableArea}}</td>
      </tr>
{{/if}}
  {{/if}}

      {{#if summaryData.investmentType}}
      <tr>
        <td>Investment Type:</td>
        <td>{{summaryData.investmentType}}</td>
      </tr>
      {{/if}}
      {{#if summaryData.investmentSubtype}}
      <tr>
        <td>Investment Subtype:</td>
        <td>{{summaryData.investmentSubtype}}</td>
      </tr>
      {{/if}}
      {{#if formattedData.debt}}
      <tr>
      <td>Debt:</td>
      <td>{{formattedData.debt}}</td>
    </tr>
    {{/if}}
    
      {{#if summaryData.ownershipType}}
      <tr>
        <td>Ownership Type:</td>
        <td>{{summaryData.ownershipType}}</td>
      </tr>
      {{/if}}
      {{#if formattedData.ownerShip}}
      <tr>
        <td>Ownership %:</td>
        <td>{{formattedData.ownerShip}}</td>
      </tr>
      {{/if}}
      
      {{#if summaryData.investmentDescription}}
      <tr>
        <td>Investment Description:</td>
        <td>{{summaryData.investmentDescription}}</td>
      </tr>
      {{/if}}
      {{#if summaryData.primaryLeaseType}}
      <tr>
        <td>Primary Lease Type:</td>
        <td>{{summaryData.primaryLeaseType}}</td>
      </tr>
      {{/if}}
      {{#if summaryData.jvPartner}}
      <tr>
        <td>JV Partner:</td>
        <td>{{summaryData.jvPartner}}</td>
      </tr>
      {{/if}}
        </table>
      </div>
    </div>

    {{#if summaryComment}}
    <table id="table-comment">
      <tr>
        <th>
          Additional Property Description
        </th>
      </tr>
      <tr>
        <td>
          {{{summaryComment.commentText}}}
        </td>
      </tr>
    </table>
    {{/if}}
  </body>
</html>

`;
export default summaryTemplate;